/* eslint-disable max-len */
import { INTL_IDS } from './messages';

export const ADD_LOAN = 'app/Settings/Loans/ADD_LOAN';
export const ADD_LOAN_FAILURE = 'app/Settings/Loans/ADD_LOAN_FAILURE';
export const ADD_LOAN_SUCCESS = 'app/Settings/Loans/ADD_LOAN_SUCCESS';

export const CANCEL_CHANGE_MAILING_ADDRESS = 'app/Settings/Loans/CANCEL_CHANGE_MAILING_ADDRESS';
export const CANCEL_CHANGE_MAILING_ADDRESS_FAILURE = 'app/Settings/Loans/CANCEL_CHANGE_MAILING_ADDRESS_FAILURE';
export const CANCEL_CHANGE_MAILING_ADDRESS_SUCCESS = 'app/Settings/Loans/CANCEL_CHANGE_MAILING_ADDRESS_SUCCESS';

export const CHANGE_INPUT = 'app/Settings/Loans/CHANGE_INPUT';

export const CHANGE_MAILING_ADDRESS = 'app/Settings/Loans/CHANGE_MAILING_ADDRESS';
export const CHANGE_MAILING_ADDRESS_FAILURE = 'app/Settings/Loans/CHANGE_MAILING_ADDRESS_FAILURE';
export const CHANGE_MAILING_ADDRESS_FORM_DOCUMENT_URL = 'https://dudhzjl76se9h.cloudfront.net/docs/Change_of_Mailing_Address_Form.pdf';
export const CHANGE_MAILING_ADDRESS_FORM_TYPE = 'app/Settings/Loans/CHANGE_MAILING_ADDRESS_FORM_TYPE';
export const CHANGE_MAILING_ADDRESS_SUCCESS = 'app/Settings/Loans/CHANGE_MAILING_ADDRESS_SUCCESS';
export const CHANGE_MAILING_ADDRESS_VALIDATION_FAILURE = 'app/Settings/Loans/CHANGE_MAILING_ADDRESS_VALIDATION_FAILURE';

export const CHANGE_PRIMARY_LOAN = 'app/Settings/Loans/CHANGE_PRIMARY_LOAN';
export const CHANGE_PRIMARY_LOAN_FAILURE = 'app/Settings/Loans/CHANGE_PRIMARY_LOAN_FAILURE';
export const CHANGE_PRIMARY_LOAN_SUCCESS = 'app/Settings/Loans/CHANGE_PRIMARY_LOAN_SUCCESS';

export const CHANGE_STEP = 'app/Settings/Loans/CHANGE_STEP';

export const CHOOSE_DOCUMENT = 'app/Settings/Loans/CHOOSE_DOCUMENT';
export const CHOOSE_DOCUMENT_CANCELLATION = 'app/Settings/Loans/CHOOSE_DOCUMENT_CANCELLATION';
export const CHOOSE_DOCUMENT_FAILURE = 'app/Settings/Loans/CHOOSE_DOCUMENT_FAILURE';
export const CHOOSE_DOCUMENT_SUCCESS = 'app/Settings/Loans/CHOOSE_DOCUMENT_SUCCESS';

export const CLOSE_MODAL_STATE = 'app/Settings/Loans/CLOSE_MODAL_STATE';

export const DOWNLOAD_DOCUMENT = 'app/Settings/Loans/DOWNLOAD_DOCUMENT';
export const DOWNLOAD_DOCUMENT_FAILURE = 'app/Settings/Loans/DOWNLOAD_DOCUMENT_FAILURE';

export const FETCH_MAILING_ADDRESS = 'app/Settings/Loans/FETCH_MAILING_ADDRESS';
export const FETCH_MAILING_ADDRESS_FAILURE = 'app/Settings/Loans/FETCH_MAILING_ADDRESS_FAILURE';
export const FETCH_MAILING_ADDRESS_SUCCESS = 'app/Settings/Loans/FETCH_MAILING_ADDRESS_SUCCESS';
export const FETCH_MAILING_ADDRESS_VALIDATION_FAILURE = 'app/Settings/Loans/FETCH_MAILING_ADDRESS_VALIDATION_FAILURE';

export const FETCH_MAILING_ADDRESS_ALL = 'app/Settings/Loans/FETCH_MAILING_ADDRESS_ALL';
export const FETCH_MAILING_ADDRESS_ALL_FAILURE = 'app/Settings/Loans/FETCH_MAILING_ADDRESS_ALL_FAILURE';
export const FETCH_MAILING_ADDRESS_ALL_SUCCESS = 'app/Settings/Loans/FETCH_MAILING_ADDRESS_ALL_SUCCESS';

export const INPUT_ERRORS = 'app/Settings/Loans/INPUT_ERRORS';

export const OPEN_MODAL_STATE = 'app/Settings/Loans/OPEN_MODAL_STATE';

export const PROCESS_DOCUMENT = 'app/Settings/Loans/PROCESS_DOCUMENT';
export const PROCESS_DOCUMENT_FAILURE = 'app/Settings/Loans/PROCESS_DOCUMENT_FAILURE';
export const PROCESS_DOCUMENT_SUCCESS = 'app/Settings/Loans/PROCESS_DOCUMENT_SUCCESS';

export const RESET_BANNER_ERROR = 'app/Settings/Loans/RESET_BANNER_ERROR';
export const RESET_ERROR_STATE = 'app/Settings/Loans/RESET_ERROR_STATE';
export const RESET_FORM_STATE = 'app/Settings/Loans/RESET_FORM_STATE';
export const RESET_FORM_TYPE = 'app/Settings/Loans/RESET_FORM_TYPE';
export const RESET_SELECTED_LOAN = 'app/Settings/Loans/RESET_SELECTED_LOAN';
export const RESET_STATE = 'app/Settings/Loans/RESET_STATE';
export const RESET_STATUS_STATE = 'app/Settings/Loans/RESET_STATUS_STATE';
export const RESET_STEP_STATE = 'app/Settings/Loans/RESET_STEP_STATE';
export const RESET_UPDATED_PRIMARY_LOAN = 'app/Settings/Loans/RESET_UPDATED_PRIMARY_LOAN';

export const SET_SELECTED_LOAN = 'app/Settings/Loans/SET_SELECTED_LOAN';

export const UPLOAD_DOCUMENT = 'app/Settings/Loans/UPLOAD_DOCUMENT';
export const UPLOAD_DOCUMENT_FAILURE = 'app/Settings/Loans/UPLOAD_DOCUMENT_FAILURE';
export const UPLOAD_DOCUMENT_SUCCESS = 'app/Settings/Loans/UPLOAD_DOCUMENT_SUCCESS';

export const ADD_LOAN_ERR_MESSAGE = 'There was an issue adding the loan.';
export const CHANGE_MAILING_ADDRESS_ERR_MESSAGE = 'There was an issue submitting your change of address request.';
export const FETCH_MAILING_ADDRESS_ERR_MESSAGE = 'There was an issue fetching your mailing address data.';

export const MANCODE_Y_TEXT = '<b>Ineligible to edit mailing address.</b>\nFor additional information, please call customer service at <a>1-877-330-4051</a>.';
export const MANCODE_Y_MULTILOAN_TEXT = '<b>Ineligible to edit 1 or more mailing addresses.</b>\nFor additional information, please call customer service at <a>1-877-330-4051</a>.';
export const MANCODE_Y_LOAN_SELECT_TEXT = '<b>Ineligible to edit.</b>\nFor additional information, please call customer service at <a>1-877-330-4051</a>.';

export const LOANS_CONTENT_DICTIONARY = {
  addLoan: {
    addLoanView: { header: INTL_IDS.LOANSCONTENT_ADDLOAN_ADDLOANVIEW_HEADER },
    confirmationView: {
      desktop: {
        header: 'Confirmation',
        subheader: INTL_IDS.LOANSCONTENT_ADDLOAN_CONFIRMATIONVIEW_SUBHEADER,
      },
      mobile: {
        header: 'Confirmation',
        subheader: INTL_IDS.LOANSCONTENT_ADDLOAN_CONFIRMATIONVIEW_SUBHEADER,
      },
    },
  },
  cancelMailingAddress: {
    confirmationView: {
      subheader: 'Success! Your pending request has been canceled',
      text: 'Your mailing address will not be changed.',
    },
    errorView: {
      desktop: { subheader: 'Sorry. We are unable to to cancel your request' },
      mobile: {
        subheader: 'There was a problem with your request',
        text: 'Please try again later. For assistance, contact {{customerServicePhoneNumber}}.',
      },
    },
    stepOneView: {
      desktop: {
        statusBannerError: 'The window to cancel your request has closed.',
        subheader: 'We’re reviewing your request',
        text: INTL_IDS.LOANSCONTENT_CANCELMAILINGADDRESS_STEPONEVIEW_DESKTOP_TEXT,
      },
      mobile: {
        statusBannerError: 'The window to cancel your request has closed.',
        subheader: 'We’re reviewing your request',
        text: INTL_IDS.LOANSCONTENT_CANCELMAILINGADDRESS_STEPONEVIEW_MOBILE_TEXT,
      },
    },
    stepTwoView: {
      subheader: 'Are you sure you want to cancel your pending request?',
      text: 'We will immediately cancel your pending request and your mailing address will not be changed.',
    },
  },
  changeMailingAddress: {
    confirmationView: {
      desktop: {
        header: 'Confirmation',
        subheader: 'Success! We received your request',
        text1: 'Please allow up to 2 business days for us to update your mailing address. We will send you an email notification once the request is processed.',
        text2: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
      },
      mobile: {
        errorText: 'We are unable to upload your documents at this time',
        header: 'Confirmation',
        subheader: 'Success! We received your request',
        text1: 'Please allow up to 2 business days for us to update your mailing address. We will send you an email notification once the request is processed.',
        text2: 'We will make every effort to provide a response to your inquiry as promptly as possible. In any event, we will do so within the time limit required by law.',
      },
    },
    reviewUploadView: {
      header: 'Almost done',
      text: 'Your request will be processed once we receive your document.',
    },
    uploadView: {
      header: 'Upload Change of Mailing Address Form',
      mobileHeader: 'Upload Form',
      mobileSubheader: 'Upload change of address form',
      subheader: 'Document Requirements',
    },
  },
};

// Change mailing address form related constants
export const ADDRESS_TYPE_DROPWDOWN_PROPS = {
  items: [
    { display: 'United States', label: 'United States', value: 'United States' },
    { display: 'International', label: 'International', value: 'International' },
  ],
  label: 'Address Type',
};

export const CHANGE_MAILING_ADDRESS_PROPS = {
  alertText: 'The change will be reflected within 2 business days after submitting an updated mailing address.',
  heading: 'Edit Mailing Address',
  multiBorrowerText: 'In addition to uploading the completed form, fill out the fields below so they match the form. Any discrepancy may cause a delay in processing.',
};

export const CANADA = 'CA';
export const INTERNATIONAL = 'International';
export const UNITED_STATES = 'United States';

export const REQUIRED_DOMESTIC_FIELDS = ['city', 'state', 'streetAddress', 'zip'];
export const REQUIRED_INTERNATIONAL_FIELDS = ['city', 'country', 'streetAddress'];
export const REQUIRED_CANADIAN_FIELDS = ['postalCode', 'province'];

/* eslint-disable quote-props */
export const REASON_CODE_DICTIONARY = {
  '3004.2002': { message: INTL_IDS.REASONCODE_3004_INVALIDREQUEST },
  '3004.2004': { message: INTL_IDS.REASONCODE_3004_INVALIDREQUEST },
  '3004.2007': { message: INTL_IDS.REASONCODE_3004_ALREADYADDED },
  '3004.2010': { message: INTL_IDS.REASONCODE_3004_MISSINGFIELDS },
  '3004.2011': { message: INTL_IDS.REASONCODE_3004_MISSINGFIELDS },
  '3004.2999': { message: INTL_IDS.REASONCODE_3004_SUCCESSFULLYADDED },
  '3006.2028': { message: INTL_IDS.REASONCODE_3004_MAINONLINEPLATFORM },
  '26000.1000': { message: INTL_IDS.REASONCODE_26000_ADDRESSCANNOTBECHANGED },
  '26001.1001': { message: 'Previous Address change request is in process' },
  '26002.2000': { field: 'company', message: INTL_IDS.REASONCODE_26002_BORROWERNAME },
  '26002.2002': { field: 'company', message: 'Invalid length. Must have a length less than or equal to 30' },
  '26002.2003': { field: 'company', message: 'Only Alpha Numeric characters allowed' },
  '26002.2005': { field: 'apartment', message: 'Invalid length. Must have a length less than or equal to 30' },
  '26002.2006': { field: 'apartment', message: 'Only Alpha Numeric characters allowed' },
  '26002.2007': { field: 'streetAddress', message: 'Street Address is required' },
  '26002.2008': { field: 'streetAddress', message: 'Invalid length. Must have a length less than or equal to 30' },
  '26002.2009': { field: 'streetAddress', message: 'Only Alpha Numeric characters allowed' },
  '26002.2010': { field: 'city', message: 'City is required' },
  '26002.2011': { field: 'city', message: 'Invalid length. Must have a length less than or equal to 21' },
  '26002.2012': { field: 'city', message: 'Only Alpha Numeric characters allowed' },
  '26002.2013': { field: 'state', message: 'Address State is required' },
  '26002.2016': { field: 'zip', message: 'Address Postal Code is required' },
  '26002.2017': { field: 'postalCode', message: 'Address Postal Code cannot have more than 9 characters' },
  '26002.2018': { field: 'postalCode', message: 'Postal Code is invalid' },
  '26002.2019': { message: 'Address change request not allowed' },
  '26002.2020': { field: 'city', message: 'Address City is required' },
  '26003.3000': { message: 'Address change cancel request not allowed' },
};
